/*
 *  Copyright
 *
 *  Tegona S.A.
 *
 *  Tegona JS © 2017, Tegona S.A.
 *
 *  ALL RIGHTS RESERVED. THIS PROGRAM CONTAINS MATERIAL PROTECTED
 *  UNDER INTERNATIONAL AND SWITZERLAND COPYRIGHT LAWS AND TREATIES.
 *  ANY UNAUTHORIZED USE OF THE PROGRAM, INCLUDING REPRODUCTION,
 *  MODIFICATION, TRANSFER, TRANSMITTAL OR REPUBLICATION OF THIS
 *  MATERIAL IN ANY FORM OR BY ANY MEANS IS PROHIBITED WITHOUT
 *  SPECIFIC WRITTEN PERMISSION OF THE COPYRIGHT HOLDER.
 *
 *  copyright@tegona.com
*/

import React from 'react'
import R from 'ramda'
import autoBind from 'react-autobind'
import moment from 'moment'
import { injectIntl } from 'react-intl'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Divider, CircularProgress, Checkbox, ListItem as MaterialListItem } from 'material-ui'
import { List } from '@material-ui/core'

import { pink600 } from 'material-ui/styles/colors'
import { TextField } from 'generic/form'
import Card from 'generic/card/Card'
import AlertModal from 'generic/dialog/AlertModal'

import * as actions from 'actions/ApplicantPrestation'
import * as invitationActions from 'actions/Invitation'
import * as constants from 'constants/Prestation'
import * as headerConstants from 'constants/Header'
import * as loginConstants from 'constants/Login'

import ActionPanel from './ActionPanel'
import ProposalFormPanel from './ProposalFormPanel'
import PrestationProposalPanel from './PrestationProposalPanel'
import InformationPanel from './InformationPanel'
import ContributorsPanel from './ContributorsPanel'
import MoreInformationPanel from './MoreInformationPanel'
import ValidationInformationPanel from './ValidationInformationPanel'
import InvitationPanel from './InvitationPanel'
import HistoryPanel from './HistoryPanel'

import 'resources/styles/applicant/Dashboard.css'

class Detail extends React.Component {

  constructor (props) {
    super(props)
    autoBind(this)

    this.state = {
      showCancelConfirmation: false,
      showProposal: false,
      loading: props.loading,
      comment: '',
      disableProposal: true,
      billing: true,
      prestation: props.prestation,
      invitations: undefined,
      histories: []
    }
  }

  componentDidUpdate (prevProps) {
    if (this.props.prestation &&
        this.props.prestation !== prevProps.prestation) {
      this.handleLoadInvitation()

      actions.getPrestationHistories(this.props.prestation)
        .then((histories) => {
          this.setState({
            histories: histories
          })
        })

      this.setState({
        prestation: this.props.prestation,
        disableProposal: (this.props.prestation &&
                         (this.props.prestation.interpreter_ongoing_proposals_count > 0 ||
                          this.props.prestation.applicant_ongoing_proposals_count > 0)),
        showProposal: false
      })
    }
  }

  handleLoadInvitation() {
    invitationActions.getInvitations(this.props.prestation)
      .then((objs) => {
        let invitations = new Map()

        objs.map((obj) => {
          const date = moment(obj.sent_date).format('YYYY-MM-DD')
          let elements = []

          if (invitations.get(date)) {
            elements = invitations.get(date)
          }

          elements.push(obj)

          invitations.set(date, elements)
        })

        this.setState({
          invitations: invitations
        })
      })
  }

  applicant () {
    const firstName = R.path(['applicant', 'identities', 0, 'first_name'], this.props.prestation) || ''
    const lastName = R.path(['applicant', 'identities', 0, 'last_name'], this.props.prestation) || ''
    const entity = R.path(['applicant', 'entities', 0, 'name'], this.props.prestation)

    let text = entity
    if (firstName && lastName) {
      text += ' - ' + firstName +  ' ' + lastName
    }

    return text
  }

  interpreter (obj) {
    if (!R.path(['interpreter', 'uid'], obj)) {
      return this.props.intl.formatMessage(constants.messages.DETAIL_NO_INTERPRETER_MESSAGE)
    }

    let text = ''
    if (R.path(['interpreter', 'identities', 0, 'title'], obj)) {
      text += R.path(['interpreter', 'identities', 0, 'title'], obj) + ' '
    }

    text += R.path(['interpreter', 'identities', 0, 'first_name'], obj) + ' ' +
            R.path(['interpreter', 'identities', 0, 'last_name'], obj)

    return text
  }

  handleChangeAdminRemark (event) {
    const value = event.target.value

    this.setState({
      prestation: {
        ...this.state.prestation,
        admin_remarks: value
      }
    })
  }

  handleAdminRemark (event) {
    const value = event.target.value
    const prestation = {
      ...this.state.prestation,
      admin_remarks: value,
      billing: undefined
    }

    actions.postPrestationAdmin(prestation)
      .then((result) => {
        this.props.actions.setNotification(
          this.props.intl.formatMessage(headerConstants.messages.UPDATE_SUCCESS, {id:result.data.object.id}),
          headerConstants.NOTIF_SUCCESS
        )
      })
  }

  cancelPrestation () {
    this.setState({
      showCancelConfirmation: true
    })
  }

  handleCancellationDialogCancel () {
    this.setState({
      showCancelConfirmation: false,
      comment: '',
      billing: true
    })
  }

  handleCancellationCommentChange (event, value) {
    this.setState({
      comment: value
    })
  }

  handleBillingChange (event, value) {
    this.setState({
      billing: value
    })
  }

  handleCancellationDialogConfirm () {
    this.setState({
      showCancelConfirmation: false
    })

    this.props.actions.cancelPrestation(this.state.prestation, this.state.comment, this.state.billing)
      .then((prestation) => {
        if (this.props.handleUpdatedPrestation) {
          this.props.handleUpdatedPrestation(this.state.prestation)
        }

        if (!this.props.user.is_staff) return

        const obj = {
          ...this.state.prestation,
          billing: this.state.billing
        }

        return actions.postPrestationAdmin(obj)
      })
      .finally(() => {
        this.setState({
          comment: '',
          billing: true
        })
      })
  }

  handleProposalPanel () {
    this.setState({showProposal: !this.state.showProposal})
  }

  isPrestationValidationPanelAvailable () {
    const prestationStep = this.props.prestation.workflow_objects[0].step_name

    return prestationStep === constants.TO_VALIDATE_PRESTATION_STATUS ||
           prestationStep === constants.VALIDATED_PRESTATION_STATUS ||
           prestationStep === constants.PAID_PRESTATION_STATUS ||
           prestationStep === constants.INVOICED_PRESTATION_STATUS ||
           prestationStep === constants.TO_VERIFY_PRESTATION_STATUS ||
           prestationStep === constants.CLOSED_PRESTATION_STATUS
  }

  render () {
    const prestation = this.props.prestation

    if (this.props.loading) {
      return (
        <div style={{textAlign: 'center', paddingTop: 100}}>
          <CircularProgress color={pink600} size={100} thickness={5} />
        </div>
      )
    }

    if (!this.state.prestation ||
        !this.props.prestation) {
      return null
    }

    const isStaff = this.props.user.is_staff
    const isInterpreter = this.props.user.role === loginConstants.INTERPRETER_ROLE

    return (
      <div>
        <Card title={this.props.intl.formatMessage(constants.messages.DETAIL_TITLE_LABEL)}
          subTitle={this.props.prestation.id
            ? this.props.intl.formatMessage(constants.messages.SUB_DETAIL_TITLE_LABEL) + ' ' + this.props.prestation.id : undefined}
        >
          <a
            style={{display: 'none'}}
            ref={link => { this.link = link }}
          >
          </a>
          <List style={{padding: 0}}>
            <ActionPanel
              prestation={this.state.prestation}
              disableProposal={this.state.disableProposal}
              cancelPrestation={this.cancelPrestation}
              handleProposal={this.handleProposalPanel}
              handleUpdatedPrestation={this.props.handleUpdatedPrestation}
              histories={this.state.histories}
            />

            <Divider />

            <ProposalFormPanel
              show={this.state.showProposal}
              prestation={prestation}
              handleProposalPanel={this.handleProposalPanel}
            />

            <Divider />

            <InformationPanel
              prestation={prestation}
              style={styles.listStyle}
            />

            <Divider />

            <ContributorsPanel
              prestation={prestation}
              style={styles.listStyle}
              itemStyle={styles.listItemStyle}
              applicant={this.applicant()}
              interpreter={this.interpreter(this.props.prestation)}
            />

            <Divider/>

            <MoreInformationPanel
              prestation={this.props.prestation}
              handleUpdatedPrestation={this.props.handleUpdatedPrestation}
            />

            {
              this.isPrestationValidationPanelAvailable()
              ? <ValidationInformationPanel
                  prestation={this.props.prestation}
                  handleUpdatedPrestation={this.props.handleUpdatedPrestation}
                />
              : undefined
            }

            <InvitationPanel
              invitations={this.state.invitations}
              style={styles.listStyle}
              itemStyle={styles.listItemStyle}
              interpreter={this.interpreter}
            />

            <PrestationProposalPanel
              actions={this.props.actions}
              prestation={prestation}
              applicantName={this.applicant()}
              handleUpdatedPrestation={this.props.handleUpdatedPrestation}
            />

            <HistoryPanel
              prestation={prestation}
              histories={this.state.histories}
            />

            {
              isStaff
              ? <div>
                <Divider/>
                <MaterialListItem
                  primaryText={this.props.intl.formatMessage(constants.messages.PRESTATION_ADMIN_REMARKS_LABEL)}
                  initiallyOpen={
                    this.props.prestation.admin_remarks !== null && 
                    this.props.prestation.admin_remarks.length > 0
                  }
                  primaryTogglesNestedList={true}
                  nestedItems={[
                    <TextField
                      key={1}
                      name='admin_remarks'
                      style={{padding: '10px 16px 10px 16px', width: '90%'}}
                      fullWidth={false}
                      multiLine={true}
                      rows={2}
                      value={this.state.prestation.admin_remarks || ''}
                      onBlur={this.state.prestation.admin_remarks ||
                              this.state.prestation.admin_remarks !== this.props.prestation.admin_remarks ? this.handleAdminRemark : undefined}
                      onChange={this.handleChangeAdminRemark}
                      floatingLabelText={this.props.intl.formatMessage(constants.messages.PRESTATION_ADMIN_REMARKS_MESSAGE)}
                    />
                  ]}
                />
              </div>
              : undefined
            }

          </List>
        </Card>

        <AlertModal
          open={this.state.showCancelConfirmation}
          title={this.props.intl.formatMessage(constants.messages.CANCELLATION_CONFIRMATION_FIELD_TITLE)}
          type={AlertModal.CONFIRM}
          handleCancel={this.handleCancellationDialogCancel}
          handleConfirm={this.handleCancellationDialogConfirm}
          cancellationLabel={isInterpreter ? this.props.intl.formatMessage(constants.messages.NO_CANCELLATION_ACTION) : undefined}
          confirmationLabel={isInterpreter ? this.props.intl.formatMessage(constants.messages.YES_CANCELLATION_ACTION) : undefined}
          confirmDisabled={isInterpreter && !this.state.comment}
        >
          <div className='row'>
            {
              isInterpreter
              ? this.props.intl.formatMessage(constants.messages.CANCELLATION_CONFIRMATION_FIELD_MESSAGE_MANDATORY)
              : this.props.intl.formatMessage(constants.messages.CANCELLATION_CONFIRMATION_FIELD_MESSAGE_OPTIONAL)
            }
          </div>

          <div className='row'>
            <TextField
              name='comment'
              fullWidth={true}
              multiLine={true}
              rows={2}
              value={this.state.comment}
              meta={{mandatory: isInterpreter}}
              floatingLabelText={
                isInterpreter
                ? this.props.intl.formatMessage(constants.messages.CANCELLATION_COMMENT_LABEL_MANDATORY)
                : this.props.intl.formatMessage(constants.messages.CANCELLATION_COMMENT_LABEL_OPTIONAL)
              }
              onChange={this.handleCancellationCommentChange}
            />
          </div>
          { isStaff
            ? <div className='row'>
              <Checkbox
                label={this.props.intl.formatMessage(constants.messages.BILLING_LABEL)}
                checked={this.state.billing}
                onCheck={this.handleBillingChange}
              />
            </div>
            : undefined
          }
        </AlertModal>
      </div>
    )
  }
}

const styles = {
  listStyle: {
    marginLeft: 15,
    marginRight: 15,
    padding: 4
  },
  listItemStyle: {
    padding: 0,
    marginTop: 10,
    marginBottom: 10,
    display: 'flex',
    flexWrap: 'wrap',
    overflow: 'hidden',
    wordWrap: 'break-word',
    overflowWrap: 'break-word'
  }
}

const mapStateToProps = (state) => ({
  user: state.User.user,
})

const mapActionsToProps = (dispatch) => ({
  actions: bindActionCreators(actions, dispatch),
})

export default connect(
  mapStateToProps,
  mapActionsToProps
)(injectIntl(Detail))



// WEBPACK FOOTER //
// ./src/components/applicant/prestation/dashboard/Detail.js